const GUIDE_SEEN_KEY = "moveTranscript.guideSeen";

export const hasSeenMoveGuide = () => {
  try {
    return window.localStorage.getItem(GUIDE_SEEN_KEY) === "true";
  } catch {
    return false;
  }
};

export const markMoveGuideSeen = () => {
  try {
    window.localStorage.setItem(GUIDE_SEEN_KEY, "true");
  } catch {
  }
};
